const prefix = 'INITIAL_ACTION';
export const GET_INITIAL_INFO = `${prefix}GET_INITIAL_INFO`;
export const SET_INITIAL_INFO = `${prefix}SET_INITIAL_INFO`;
export const SET_LOGGEDIN_INFO = `${prefix}SET_LOGGEDIN_INFO`;

export const getInitialInfo = data => ({
  type: GET_INITIAL_INFO,
  data
});
